import React, { useEffect, useState } from 'react';
import WelcomeDialog from "../../components/login/WelcomeDialog";
import { Button, Row, Col } from 'react-bootstrap';
import Activity from '../../components/ReportHeadmaster/Activity';
import Overview from '../../components/ReportHeadmaster/Overview';

const ReportMainHeadmaster = props => {

    const [currentTab, setCurrentTab] = useState('overview');
    const [fixedTop, setFixedTop] = useState(false);
    const handleScroll = () => {
        const position = window.pageYOffset;
        position >= 50 ? setFixedTop(true) : setFixedTop(false);
    };


    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [])

    return (
        <>
            <Row className='report-headmaster font-sarabun'>
                <Col xs={12} className={`${fixedTop ? 'fixed-top' : ''} tab-switcher with-box-shadow p-0`}>
                    <div className='main-detail d-switcher text-center'>
                        <Button className={`${currentTab == 'overview' ? 'active' : 'inactive'} switcher`} onClick={() => setCurrentTab('overview')} >ภาพรวมของโรงเรียน</Button>
                        <Button className={`${currentTab == 'activity' ? 'active' : 'inactive'} switcher mt-2 mt-lg-0 ml-lg-3`} onClick={() => setCurrentTab('activity')} >ข้อมูลกิจกรรมรายห้อง</Button>
                    </div>
                </Col>
                <Col xs={12} className={`${fixedTop ? 'content-spacing' : ''} content-switcher`}>
                    <div className='main-detail'>
                        {currentTab == 'overview' ? <Overview /> : null}
                        {currentTab == 'activity' ? <Activity /> : null}
                    </div>
                </Col>
            </Row>
            <WelcomeDialog />
        </>
    )


}

export default ReportMainHeadmaster